import axios from "axios";
import { payment_url } from "../bootapi";
import { ngrok_url } from "../bootapi";

export const getAppConf = (val) => {
  return axios.get(`${payment_url}/subsapp/app_conf_value?key_name=${val}`);
};
export const seventhplans = () => {
  return axios.get(`${payment_url}/subsapp/subscription_plan`);
};
export const activeSubscription = (id, token) => {
  return axios.get(
    `${payment_url}/subsapp/subscription_detail?user_id=${id}&is_active=True`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
};

export const getallsubscriptiondetail = (id, token) => {
  return axios.get(`${payment_url}/subsapp/subscription_detail?user_id=${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
export const createSubscription = (formData, token) => {
  return axios.post(`${payment_url}/subsapp/subscription_create`, formData, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
// export const createStripeSubscription = (formData, token) => {
//   return axios.post(`${payment_url}/subsapp/charge_session`, formData, {
//     headers: { Authorization: `Bearer ${token}` },
//   });
// };
export const createStripeSubscription = (formData, token) => {
  return axios.post(
    `${payment_url}/subsapp/subscription_create_intent`,
    formData,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
};

export const updateStripePayment = (formData, token) => {
  return axios.post(`${payment_url}/subsapp/change_card_intent`, formData, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
export const updateStripePaymentId = (formData, token) => {
  return axios.put(`${payment_url}/subsapp/change_card_intent`, formData, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
export const getTransactionHistory = (user_Id, token) => {
  return axios.get(`${payment_url}/subsapp/customer_history?user=${user_Id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
export const getcardDetails = (id, token) => {
  return axios.get(`${payment_url}/subsapp/card_details?user_id=${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
//this is an old api
export const couponCheck = (coupon, subscription) => {
  return axios.get(
    `${payment_url}/subsapp/coupon_check?coupon=${coupon}&subscription=${subscription}`
  );
};
export const couponCheckNew = (formData) => {
  return axios.post(`${payment_url}/subsapp/coupon_check`, formData);
};
export const giftCouponCheck = (data) => {
  return axios.post(`${payment_url}/subsapp/gift_check`, data);
};
export const updatePlan = (body, token) => {
  return axios.post(`${payment_url}/subsapp/update_plan`, body, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
export const subscriptionCancel = (obj, token) => {
  return axios.post(`${payment_url}/subsapp/subscription_cancel`, obj, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
export const createbetaUser = (formdata) => {
  return axios.post(`${payment_url}/subsapp/beta_user`, formdata);
};
export const sendgiftcard = (formdata, token) => {
  return axios.post(`${payment_url}/subsapp/send_gift_card`, formdata, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const journalpasswordchange = (data, token) => {
  return axios.post(`${payment_url}/subsapp/journal_password_validate`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
export const journalpasswordCreate = (data, token) => {
  return axios.post(`${payment_url}/subsapp/journal_password_create`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
export const appreview = (body) => {
  axios.post(`${payment_url}/subsapp/review`, body).then((res) => {});
};

export const registrationMail = (body) => {
  axios.post(`${payment_url}/subsapp/registration`, body).then((res) => {});
};
export const createGiftCard = (formdata) => {
  return axios.post(`${payment_url}/subsapp/send_gift_card`, formdata);
};

export const sendGiftCardSuccess = (data) => {
  return axios.put(`${payment_url}/subsapp/send_gift_card`, data);
};
export const sendGiftCardSuccessNew = (data) => {
  return axios.post(`${payment_url}/subsapp/send_gift_card`, data);
};

export const contactus = (data) => {
  return axios.post(`${payment_url}/subsapp/contact_us`, data);
};

export const getGiftCardDetails = (eventId) => {
  return axios.get(`${payment_url}/subsapp/send_gift_card?event_id=${eventId}`);
};

export const getGiftCardSuccessDetails = (eventId) => {
  return axios.get(`${payment_url}/subsapp/gift_card?event_id=${eventId}`);
};

export const getGiftDetailsHistory = (data, token) => {
  return axios.post(`${payment_url}/subsapp/gift_card_details`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
export const getSubscriptionById = (sub_id, user_id, token) => {
  return axios.get(
    `${payment_url}/subsapp/subscription_detail?subscription_id=${sub_id}&user_id=${user_id}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
};
export const getPendingPayment = (customer_id, user_id, token) => {
  return axios.get(
    `${payment_url}/subsapp/incomplete?user=${user_id}&customer_id=${customer_id}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
};
export const getThreeDIncomplete = (data, token) => {
  return axios.post(`${payment_url}/subsapp/incomplete`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
export const getAfterSuccessThreeD = (data, token) => {
  return axios.put(`${payment_url}/subsapp/incomplete`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
export const unsubscribeGuest = (email) => {
  return axios.get(`${payment_url}/subsapp/guest_unsubscribe?email=${email}`);
};
export const unsubscribeNewsLetter = (email) => {
  return axios.get(
    `${payment_url}/subsapp/newslatter_unsubscribe?email=${email}`
  );
};
export const sendReview = (data, token) => {
  return axios.post(`${payment_url}/subsapp/send_review`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
export const getReviewList = (type) => {
  return axios.get(
    `${payment_url}/subsapp/users_review?publish=True&site=${type}`
  );
};

export const dataDeleteRequest = (data, token) => {
  return axios.post(`${payment_url}/subsapp/data_delete_request`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const reactivateSubscription = (data, token) => {
  return axios.post(`${payment_url}/subsapp/reactivate`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
